import { InternalAxiosRequestConfig } from 'axios';
import { DIMENSIONALITY_VALUES } from 'constants/businessTool';
import { useUnitRecalculationStore } from 'store/useUnitRecalculationStore';

import { ClientError } from '../types';

const CALCULATION_UNIT_PATH = new RegExp(`/(${Object.values(DIMENSIONALITY_VALUES).join('|')})(?:/|$|\\?)`);
const PERFORMANCE_INVESTMENT_PATH = /\/performance\/investment\//;

const getRequestUrl = (config?: InternalAxiosRequestConfig) => {
  if (!config) return '';

  return `${config.baseURL ?? ''}${config.url ?? ''}`;
};

const isCalculationRequest = (config?: InternalAxiosRequestConfig) => {
  if (!config) return false;

  const method = config.method?.toLowerCase();

  return (method === 'put' || method === 'post') && CALCULATION_UNIT_PATH.test(getRequestUrl(config));
};

const isPerformanceInvestmentRequest = (config?: InternalAxiosRequestConfig) => {
  return isCalculationRequest(config) && PERFORMANCE_INVESTMENT_PATH.test(getRequestUrl(config));
};

export const markCalculationRequest = (config: InternalAxiosRequestConfig) => {
  if (isCalculationRequest(config)) {
    if (isPerformanceInvestmentRequest(config)) {
      useUnitRecalculationStore.getState().begin();
    }

    useUnitRecalculationStore.getState().startRequest();
  }

  return config;
};

export const unmarkCalculationRequest = (config?: InternalAxiosRequestConfig) => {
  if (isCalculationRequest(config)) {
    useUnitRecalculationStore.getState().endRequest();
  }
};

export const unmarkCalculationRequestFromError = (error: ClientError) => {
  unmarkCalculationRequest(error.config);
  return Promise.reject(error);
};
